module.exports = "<span class=\"selected\"\n    [ngClass]=\"{placeholder: !selection}\"\n    (click)=\"expanded = !expanded\">\n    {{(selection && selection.display) || placeholder}}\n</span>\n<ul class=\"items\"\n    *ngIf=\"expanded\">\n    <li class=\"item\"\n        *ngFor=\"let item of list\"\n        (click)=\"select(item)\">\n        {{item.display}}\n    </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./~/text-loader!./_src/ui/elements/dropdownNg2.html
// module id = 507
// module chunks = 1 4